import { render, staticRenderFns } from "./ProjectAccountingBalanceSheetPage.vue?vue&type=template&id=52fcab80&"
import script from "./ProjectAccountingBalanceSheetPage.vue?vue&type=script&lang=js&"
export * from "./ProjectAccountingBalanceSheetPage.vue?vue&type=script&lang=js&"
import style0 from "./ProjectAccountingBalanceSheetPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports